/**
 * lenis-scroll.js — Tuesday London
 * Proper Lenis v1.3 integration + scroll-to-top button
 * ──────────────────────────────────────────────────────
 * Shopify 2.0 themes often use `.page-wrapper` as the scroll container
 * on desktop instead of `window` to support drawer menus.
 * This script detects the correct scrolling element and binds Lenis to it.
 */

(function () {
  'use strict';

  if (window.__TL_init) return;
  window.__TL_init = true;

  function run() {
    var LenisClass = window.Lenis || globalThis.Lenis;

    if (!LenisClass) {
      if (!window.__TL_lenis_retried) {
        window.__TL_lenis_retried = true;
        setTimeout(run, 100);
      }
      return;
    }

    // ── Skip on prefers-reduced-motion ─────────────────────────
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      buildScrollToTop(null, null);
      return;
    }

    // ── Skip on pure touch mobile (preserve native scroll) ─────
    var isCoarse = window.matchMedia('(pointer: coarse)').matches;
    if (isCoarse && navigator.maxTouchPoints > 1) {
      buildScrollToTop(null, null);
      return;
    }

    // ── Determine Scroll Container ──────────────────────────────
    var pageWrapper = document.querySelector('.page-wrapper');
    var isWrapperScrolling = false;
    
    if (pageWrapper) {
      var style = window.getComputedStyle(pageWrapper);
      if (style.overflowY === 'auto' || style.overflowY === 'scroll') {
        isWrapperScrolling = true;
      }
    }

    var scrollWrapper = isWrapperScrolling ? pageWrapper : window;
    var scrollContent = isWrapperScrolling ? pageWrapper.firstElementChild : document.documentElement;

    // ── Create Lenis instance ───────────────────────────────────
    var lenis = new LenisClass({
      wrapper: scrollWrapper,
      content: scrollContent,
      duration: 1.2,
      easing: function (t) { return t === 1 ? 1 : 1 - Math.pow(2, -10 * t); },
      smoothWheel: true,
      wheelMultiplier: 1.0,
      autoRaf: true,
      prevent: function (node) {
        return (
          node.closest &&
          (node.closest('[data-no-lenis]') ||
           node.closest('.cart-drawer') ||
           node.closest('.dialog') ||
           node.closest('[data-scroll-lock]') ||
           node.closest('details[open]'))
        );
      }
    });

    window.__TL_lenis = lenis;

    // ── Sync with GSAP ScrollTrigger if available ───────────────
    lenis.on('scroll', function () {
      if (typeof ScrollTrigger !== 'undefined') ScrollTrigger.update();
    });

    // ── Smooth anchor links ─────────────────────────────────────
    document.addEventListener('click', function (e) {
      var anchor = e.target.closest('a[href^="#"]');
      if (!anchor) return;
      var hash = anchor.getAttribute('href');
      if (!hash || hash === '#') return;
      var target = document.querySelector(hash);
      if (!target) return;
      e.preventDefault();
      var hdr = document.querySelector('#header-component');
      var offset = hdr ? hdr.offsetHeight : 0;
      lenis.scrollTo(target, { offset: -offset, duration: 1.2 });
    }, { passive: false });

    // ── Build scroll-to-top button ──────────────────────────────
    buildScrollToTop(lenis, isWrapperScrolling ? pageWrapper : window);
  }

  function buildScrollToTop(lenis, scrollContainer) {
    if (document.getElementById('tl-scroll-top')) return;

    var style = document.createElement('style');
    style.textContent = '\
      #tl-scroll-top {\
        position:fixed; bottom:32px; right:24px; z-index:99999;\
        width:46px; height:46px; border-radius:50%;\
        background:#cc0000; color:#fff; border:none; cursor:pointer;\
        display:flex; align-items:center; justify-content:center;\
        opacity:0; transform:translateY(20px);\
        transition:opacity .35s ease, transform .35s ease, background .25s ease;\
        pointer-events:none;\
        box-shadow:0 4px 20px rgba(204,0,0,.4);\
      }\
      #tl-scroll-top.tl-show { opacity:1; transform:translateY(0); pointer-events:auto; }\
      #tl-scroll-top:hover { background:#a50000; }\
      @media(max-width:768px) { #tl-scroll-top { bottom:20px; right:16px; width:40px; height:40px; } }\
    ';
    document.head.appendChild(style);

    var btn = document.createElement('button');
    btn.id  = 'tl-scroll-top';
    btn.setAttribute('aria-label', 'Scroll to top');
    btn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="18 15 12 9 6 15"/></svg>';
    document.body.appendChild(btn);

    // Show/hide on scroll
    if (lenis) {
      lenis.on('scroll', function (e) {
        if (e.scroll > 400) btn.classList.add('tl-show');
        else                 btn.classList.remove('tl-show');
      });
    } else {
      var listenerTarget = scrollContainer || window;
      listenerTarget.addEventListener('scroll', function () {
        var y = listenerTarget.scrollTop !== undefined ? listenerTarget.scrollTop : (window.scrollY || window.pageYOffset || 0);
        if (y > 400) btn.classList.add('tl-show');
        else         btn.classList.remove('tl-show');
      }, { passive: true });
    }

    btn.addEventListener('click', function () {
      if (lenis) {
        lenis.scrollTo(0, { duration: 1.3 });
      } else {
        if (scrollContainer && scrollContainer.scrollTo) {
          scrollContainer.scrollTo({ top: 0, behavior: 'smooth' });
        } else {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      }
    });
  }

  // ── Boot ─────────────────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  // ── Shopify Theme Editor ─────────────────────────────────────
  document.addEventListener('shopify:section:load', function () {
    if (window.__TL_lenis) {
      window.__TL_lenis.destroy();
      window.__TL_lenis = null;
    }
    window.__TL_init = false;
    setTimeout(function () {
      window.__TL_init = true;
      run();
    }, 150);
  });

  // ── Responsive Breakpoint Handling ───────────────────────────
  var scrollMediaQuery = window.matchMedia('(min-width: 991px)');
  scrollMediaQuery.addEventListener('change', function () {
    if (window.__TL_lenis) {
      window.__TL_lenis.destroy();
      window.__TL_lenis = null;
    }
    
    var oldBtn = document.getElementById('tl-scroll-top');
    if (oldBtn) {
      oldBtn.parentNode.removeChild(oldBtn);
    }

    window.__TL_init = false;
    setTimeout(function () {
      window.__TL_init = true;
      run();
    }, 150);
  });

}());
